import script from "./RelatedProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&setup=true&lang=js"

import "./RelatedProducts.vue?vue&type=style&index=0&id=23ff734a&lang=css"

const __exports__ = script;

export default __exports__